/* Requires: jquery.scrollify.js */

var burgerNav = (function($) {
    var self = this;
    
    var settings = {
        container: '.navbar__burger'
    };

    var init = function() {
        _burgernav();
        _navOffTop();
    };

    var _burgernav = function() {
        $(settings.container).on('click',function(e) {
            e.preventDefault();
            $('.navbar__burger, .navbar__menu, body').toggleClass('active');
        });
    };
    var _navOffTop = function() {
        var ScrollTop = 10;
        $(window).scroll(function(event){
           var st = $(this).scrollTop();
           if (st <= ScrollTop){
                $('body').removeClass('downscroll');
           } else {
                $('body').addClass('downscroll');
           }
           // lastScrollTop = st;
        });
    };

     return {
        init: init
    };

})(jQuery);

$(document).ready(function($) {
    burgerNav.init();
});